// upload.cache.ts
interface IUploadCacheEntry {
  body: Blob;
  name: string;
  size: number;
  localURL?: string;
  storedAt?: number;
};

const uploadCache = new Map<number, IUploadCacheEntry>();

export function cachePut(id: number, entry: IUploadCacheEntry) {
  uploadCache.set(id, {...entry, storedAt: Date.now()});
}

export function cachePeek(id: number): IUploadCacheEntry | undefined {
  const data = uploadCache.get(id);
  return data;
}

export function cacheDelete(id: number) {
  uploadCache.delete(id);
}

export function cachePruneOlderThan(maxAgeMs: number) {
  const now = Date.now();
  uploadCache.forEach((entry, id) => {
    if (typeof entry.storedAt !== "number" || now - entry.storedAt > maxAgeMs) {
      uploadCache.delete(id);
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/file/upload.cache.ts